module.exports = __webpack_public_path__ + "img/cart-more.942a7d2d.png";